import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import useRightPath from '~/composables/useRightPath';
import { useGetTranslations } from '~/composables/useGetTranslations';
export default (function () {
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var _useRightPath = useRightPath(),
    getProductPrefix = _useRightPath.getProductPrefix;
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app;
  var getProductBreadcrumbs = function getProductBreadcrumbs(product) {
    var _product$_original, _product$_original$ma, _product$_original$ma2, _product$attributesRa, _mainCategoryAttribut;
    if (!product) {
      return [];
    }
    var categories = product === null || product === void 0 ? void 0 : (_product$_original = product._original) === null || _product$_original === void 0 ? void 0 : (_product$_original$ma = _product$_original.masterData) === null || _product$_original$ma === void 0 ? void 0 : (_product$_original$ma2 = _product$_original$ma.current) === null || _product$_original$ma2 === void 0 ? void 0 : _product$_original$ma2.categories;
    var mainCategoryAttribute = product === null || product === void 0 ? void 0 : (_product$attributesRa = product.attributesRaw) === null || _product$attributesRa === void 0 ? void 0 : _product$attributesRa.find(function (attribute) {
      return attribute.name === 'main-category';
    });
    var mainCategoryTypeId = mainCategoryAttribute ? mainCategoryAttribute === null || mainCategoryAttribute === void 0 ? void 0 : (_mainCategoryAttribut = mainCategoryAttribute.value) === null || _mainCategoryAttribut === void 0 ? void 0 : _mainCategoryAttribut.id : null;
    var _findNestedId = function findNestedId(category) {
      if (category.id == mainCategoryTypeId) {
        return category.id;
      }
      return category.parent ? _findNestedId(category.parent) : false;
    };
    var categoryWithSelectedId = categories === null || categories === void 0 ? void 0 : categories.find(function (category) {
      return category.id === _findNestedId(category);
    });
    var topCategory = categoryWithSelectedId !== null && categoryWithSelectedId !== void 0 ? categoryWithSelectedId : categories === null || categories === void 0 ? void 0 : categories[0];
    if (!topCategory) {
      return [];
    }
    var categoryBreadcrumbs = getCategoryBreadcrumbs(topCategory);
    var currentBreadcrumb = {
      text: product._name,
      link: app.localePath("".concat(getProductPrefix(), "/").concat(product._slug))
    };
    return [].concat(_toConsumableArray(categoryBreadcrumbs), [currentBreadcrumb]);
  };
  var getCategoryBreadcrumbs = function getCategoryBreadcrumbs(currentCategory) {
    var _currentCategory$ance, _currentCategory$ance2;
    if (!currentCategory) {
      return [];
    }
    var homeBreadcrumb = {
      text: translate('utils.homeBreadcrumbs'),
      link: app.localePath({
        name: 'index'
      })
    };
    var currentBreadcrumb = {
      text: currentCategory.name,
      link: app.localePath({
        name: 'products-slug',
        params: {
          slug: currentCategory.slug
        }
      })
    };
    var ancestor = (_currentCategory$ance = currentCategory.ancestors) === null || _currentCategory$ance === void 0 ? void 0 : _currentCategory$ance[((_currentCategory$ance2 = currentCategory.ancestors) === null || _currentCategory$ance2 === void 0 ? void 0 : _currentCategory$ance2.length) - 1];
    var ancestorBreadcrumb = ancestor ? [{
      text: ancestor.name,
      link: app.localePath({
        name: 'products-slug',
        params: {
          slug: ancestor.slug
        }
      })
    }] : [];
    return [homeBreadcrumb].concat(ancestorBreadcrumb, [currentBreadcrumb]);
  };
  return {
    getProductBreadcrumbs: getProductBreadcrumbs,
    getCategoryBreadcrumbs: getCategoryBreadcrumbs
  };
});